<template>
  <div v-loading="showFlag">
    <!--  社内加工原価編集画面 -->
    <t-card>
      <div>
        <t-row class="marginBottom">
          <t-col :span="parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_ONE'))"
            >&nbsp;</t-col
          >
          <t-col
            :span="parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_TWENTY_TWO'))"
          >
            <!-- テーブル -->
            <div>
              <t-table
                ref="internalProcessTableData"
                :data="internalProcessTableData"
                class="table_common"
                header-cell-class-name="bg-default"
                highlight-current-row
                :height="detailHeight"
                :cell-class-name="tableCellClassName"
                border
                fit
              >
                <!-- テーブルの列 -->
                <t-table-column
                  v-for="(column, index) in columns"
                  :key="index"
                  :type="column.type"
                  :prop="column.prop"
                  :label="column.label"
                  :min-width="column.width"
                  :align="column.align"
                  :header-align="column.headerAlign"
                  :class-name="column.class"
                  :show-overflow-tooltip="column.overflowTooltip"
                >
                  <template slot-scope="scope">
                    <!-- <t-input-number
                      v-if="columnEditable.includes(column.prop)"
                      class="cell_input_number"
                      :controls="false"
                      :precision="0"
                      :min="0"
                      :max="999999"
                      v-model="scope.row[column.prop]"
                      @change="changeCellData(scope.row)"
                    ></t-input-number> -->
                    <!--UPD 2024/12/16 ZLL 課题_受注製品変更の検討 start↓ -->
                    <!-- <t-input
                      v-if="columnEditable.includes(column.prop)"
                      class="cell_input_custom"
                      :controls="false"
                      :maxlength="6"
                      v-model="scope.row[column.prop]"
                      @focus="changeCellDataToNumber(scope.row, column.prop)"
                      @blur="changeCellData(scope.row)"
                      @input="
                        scope.row[column.prop] = scope.row[column.prop].replace(
                          /[^\d]/g,
                          ''
                        )
                      "
                      :ref="`input${scope.row.index}`"
                      @keyup.native.enter="
                        focusNextInput(scope.row.index, column.prop)
                      "
                    ></t-input> -->
                    <t-input
                      v-if="columnEditable.includes(column.prop)"
                      class="cell_input_custom"
                      :controls="false"
                      :maxlength="6"
                      v-model="scope.row[column.prop]"
                      @focus="
                        changeCellDataToNumber(scope.row, column.prop, $event)
                      "
                      @blur="changeCellData(scope.row)"
                      @input="
                        scope.row[column.prop] = scope.row[column.prop].replace(
                          /[^\d]/g,
                          ''
                        )
                      "
                      :ref="`input${scope.row.index}`"
                      @keyup.native.enter="
                        focusNextInput(scope.row.index, column.prop)
                      "
                    ></t-input>
                    <span v-else>
                      {{ scope.row[column.prop] }}
                    </span>
                  </template>
                </t-table-column>
              </t-table>
            </div>
          </t-col>

          <t-col :span="parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_ONE'))"
            >&nbsp;</t-col
          >
        </t-row>
      </div>

      <div :style="{ height: bottomHeight + 'px' }">
        <t-row class="marginBottom">
          <div>
            <!-- <t-col
              :span="parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_NINETEEN'))"
              >&nbsp;</t-col
            > -->

            <!-- 確定ボタン -->
            <t-col
              :span="
                parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_TWENTY_THREE'))
              "
              align="right"
            >
              <t-button
                round
                type="warning"
                class="dialogButton_confirm_120_40"
                ref="confirmBtn"
                @click="confirmClick"
              >
                <i class="el-icon-check"></i>
                {{ $t("resource.COMMON_CONSTANT.CONFIRM") }}</t-button
              >
            </t-col>

            <t-col :span="parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_ONE'))"
              >&nbsp;</t-col
            >
          </div>
        </t-row>
      </div>
    </t-card>
  </div>
</template>
<script>
import { getUserInfo } from "@/auth";
import { t } from "@/locales";
import {
  searchProcessCostByOrderNo,
  updateProcessCostByOrderNo,
} from "@/services/order";
import {
  cmpDetailData,
  formatCurrencyToNumber,
  formatStringToCurrency,
  getDialogContentHeight,
} from "@/utils/comFunction";
import { DIALOG_LINE_HEIGHT } from "@/utils/const";
import { Message, Modal } from "@tellus/component";
export default {
  data() {
    return {
      //比較用明細情報
      cmpDetailResult: {},
      //読み込み回数
      numLoads: 1,

      //受注一覧選択情報
      internalProcessTableData: [],

      // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
      // 注文一覧(保存用)
      internalProcessInfo: [],
      // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑

      //明細情報のheight
      detailHeight: getDialogContentHeight(
        window.innerHeight,
        0,
        DIALOG_LINE_HEIGHT,
        20
      ),
      //確定ボタンのheight
      bottomHeight: DIALOG_LINE_HEIGHT,

      //仕入先見積依頼のテーブルの列
      columns: [
        // 品名
        {
          prop: "odProdName",
          label: t("resource.COMMON_CONSTANT.PRODUCT_NAME"),
          // width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
          class: "cell_txt_left",
          overflowTooltip: true,
        },
        // 図番
        {
          prop: "odProdDrawNo",
          label: t("resource.COMMON_CONSTANT.PICTURE_NO"),
          // width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
          class: "cell_txt_left",
          overflowTooltip: true,
        },
        // 材料費
        {
          prop: "odMaterialCost",
          label: t("resource.ORDER.MATERIAL_COST"),
          // width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
          width: 50,
          class: "cell_txt_right",
        },

        // 加工費
        {
          prop: "odMachineCost",
          label: t("resource.ORDER.MACHINE_COST"),
          // width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
          width: 50,
          class: "cell_txt_right",
        },

        // 処理1費用
        {
          prop: "odProcess1Cost",
          label: t("resource.ORDER.PROCESS1_COST"),
          // width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
          width: 60,
          class: "cell_txt_right",
        },

        // 処理2費用
        {
          prop: "odProcess2Cost",
          label: t("resource.ORDER.PROCESS2_COST"),
          // width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
          width: 60,
          class: "cell_txt_right",
        },

        // 処理3費用
        {
          prop: "odProcess3Cost",
          label: t("resource.ORDER.PROCESS3_COST"),
          // width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
          width: 60,
          class: "cell_txt_right",
        },

        // 処理4費用
        {
          prop: "odProcess4Cost",
          label: t("resource.ORDER.PROCESS4_COST"),
          // width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
          width: 60,
          class: "cell_txt_right",
        },

        // 小計
        {
          prop: "odInternalSumCost",
          label: t("resource.ORDER.SUBTOTAL"),
          // width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
          width: 60,
          class: "cell_txt_right",
        },
      ],

      data: null,

      //編集可能列
      columnEditable: [
        "odMaterialCost",
        "odMachineCost",
        "odProcess1Cost",
        "odProcess2Cost",
        "odProcess3Cost",
        "odProcess4Cost",
      ],

      showFlag: false,

      //製品情報
      preProducts: this.products,
    };
  },

  props: {
    //true:新規作成　false:編集
    isAdd: {
      Type: Boolean,
      default: false,
    },
    //製品一覧
    products: {
      Type: Object,
    },
    //注文基本情報
    orderEditForm: {
      Type: Object,
    },
  },

  mounted() {
    this.init(this.products);

    //テーブルの高さを監視する
    window.addEventListener("resize", this.handleResize);

    //列幅に自動調整
    //setColumnWidth(this.columns, this.internalProcessTableData);
  },

  methods: {
    // ダイアログを閉じる
    close() {
      this.$emit("cancel");
    },

    //确定ボタン
    confirmClick() {
      // フォーカス削除
      this.$refs.confirmBtn.$el.blur();

      //新規の場合、データ保存しない
      if (this.isAdd) {
        this.$emit("ok", this.internalProcessTableData);
      } else {
        // 追加されたデータ処理
        this.dataAddUpdProc();

        //編集の場合、DBにデータを保存する
        updateProcessCostByOrderNo({
          orderBasicInfo: this.orderEditForm,
          orderDetailInfoList: this.internalProcessInfo,
          loginUser: getUserInfo().UserId,
        })
          .then((res) => {
            this.$emit("ok", this.internalProcessTableData);
          })
          .catch((err) => {
            if (err.data != null) {
              Message.showError(
                t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
              );
            } else {
              Message.showError(t("message.COMMON_MESSAGE.UPDATE_FAILURE"));
            }
          })
          .finally(() => {
            this.showFlag = false;
          });
      }
    },

    // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
    // 更新/追加されたデータ処理
    dataAddUpdProc() {
      this.internalProcessInfo = [];
      this.internalProcessTableData.forEach((item, index) => {
        // 見積No.
        var odQuoteNo = this.orderEditForm.obQuoteNo;
        // 注文No.
        var odOrderNoShow = this.orderEditForm.obOrderNoShow;
        // 注文No.連番
        var odOrderNo = this.orderEditForm.obOrderNo;
        // // 注文明細No.
        // var odOrderDetailNo = index + 1;
        // // 注文製品明細No.
        // var odProdGroupNo = index + 1;

        // item.children.forEach((element, childIndex) => {
        //   this.internalProcessInfo.push({
        //     odQuoteNo: odQuoteNo, // 見積No.
        //     odProdNo: element.odProdNo, // 受注明細_受注明細No
        //     odOrderNoShow: odOrderNoShow, // 注文No.
        //     odOrderNo: odOrderNo, // 注文No.連番
        //     odOrderDetailNo: odOrderDetailNo, // 注文明細No.
        //     odProdGroupNo: odProdGroupNo, // 注文製品明細No.
        //     odQuoteChildNo: element.odQuoteChildNo, // 見積No.子番
        //     odUPrice: item.odUPrice, // 加工単価
        //     odProdQuantity: element.odProdQuantity, // 数量
        //     odCurType: item.odCurType, // 貨幣タイプ
        //     odExr: item.odExr, // レート

        //     odMaterialCost: item.odMaterialCost,
        //     odMachineCost: item.odMachineCost,
        //     odProcess1Cost: item.odProcess1Cost,
        //     odProcess2Cost: item.odProcess2Cost,
        //     odProcess3Cost: item.odProcess3Cost,
        //     odProcess4Cost: item.odProcess4Cost,
        //     odInternalSumCost: item.odInternalSumCost,
        //     odProdExKbnStr: item.odProdExKbnStr,
        //     odProdName: item.odProdName,
        //     odProdDrawNo: item.odProdDrawNo,
        //     odProdExKbn: item.odProdExKbn,

        //     odTotal:
        //       formatCurrencyToNumber(item.odUPrice) * item.odProdQuantity, // 小計
        //     odDate: element.odDate, // 手配日
        //   });
        // });
        if (item.childrenCount > 1) {
          item.children.forEach((element) => {
            this.saveDataFormat(
              item,
              element,
              odQuoteNo,
              odOrderNoShow,
              odOrderNo,
              index
            );
          });
        } else {
          this.saveDataFormat(
            item,
            item,
            odQuoteNo,
            odOrderNoShow,
            odOrderNo,
            index
          );
        }
      });
    },
    //データを保存のフォーマット
    saveDataFormat(item, element, odQuoteNo, odOrderNoShow, odOrderNo, index) {
      // 注文明細No.
      var odOrderDetailNo = index + 1;
      // 注文製品明細No.
      var odProdGroupNo = index + 1;
      this.internalProcessInfo.push({
        odQuoteNo: odQuoteNo, // 見積No.
        odProdNo: element.odProdNo, // 受注明細_受注明細No
        odOrderNoShow: odOrderNoShow, // 注文No.
        odOrderNo: odOrderNo, // 注文No.連番
        odQuoteType: element.odQuoteType, // 注文タイプ 1:製品、2:設計
        odOrderDetailNo: odOrderDetailNo, // 注文明細No.
        odProdGroupNo: odProdGroupNo, // 注文製品明細No.
        odQuoteChildNo: element.odQuoteChildNo, // 見積No.子番
        odUPrice: item.odUPrice, // 加工単価
        odProdQuantity: element.odProdQuantity, // 数量
        odCurType: item.odCurType, // 貨幣タイプ
        odExr: item.odExr, // レート

        odMaterialCost: item.odMaterialCost,
        odMachineCost: item.odMachineCost,
        odProcess1Cost: item.odProcess1Cost,
        odProcess2Cost: item.odProcess2Cost,
        odProcess3Cost: item.odProcess3Cost,
        odProcess4Cost: item.odProcess4Cost,
        odInternalSumCost: item.odInternalSumCost,
        odProdExKbnStr: item.odProdExKbnStr,
        odProdName: item.odProdName,
        odProdDrawNo: item.odProdDrawNo,
        odProdExKbn: item.odProdExKbn,
        odCloseState: element.odCloseState,
        odProdRemarks: element.odProdRemarks,

        odTotal: formatCurrencyToNumber(item.odUPrice) * item.odProdQuantity, // 小計
        odDate: element.odDate, // 手配日
      });
    },

    // 入力ボックスをクリックの場合、値をすべて選択します
    selectValue(e) {
      e.target.select();
    },
    // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑

    //データの変換処理
    dataProcess() {
      this.internalProcessTableData.map((element) => {
        element.odMaterialCost = isNaN(element.odMaterialCost)
          ? 0
          : element.odMaterialCost;

        element.odMachineCost = isNaN(element.odMachineCost)
          ? 0
          : element.odMachineCost;

        element.odProcess1Cost = isNaN(element.odProcess1Cost)
          ? 0
          : element.odProcess1Cost;

        element.odProcess2Cost = isNaN(element.odProcess2Cost)
          ? 0
          : element.odProcess2Cost;

        element.odProcess3Cost = isNaN(element.odProcess3Cost)
          ? 0
          : element.odProcess3Cost;

        element.odProcess4Cost = isNaN(element.odProcess4Cost)
          ? 0
          : element.odProcess4Cost;

        element.odInternalSumCost = formatStringToCurrency(
          element.odMaterialCost +
            element.odMachineCost +
            element.odProcess1Cost +
            element.odProcess2Cost +
            element.odProcess3Cost +
            element.odProcess4Cost
        );

        //材料費
        element.odMaterialCost = formatStringToCurrency(element.odMaterialCost);

        //加工費
        element.odMachineCost = formatStringToCurrency(element.odMachineCost);

        //処理1費用
        element.odProcess1Cost = formatStringToCurrency(element.odProcess1Cost);

        //処理2費用
        element.odProcess2Cost = formatStringToCurrency(element.odProcess2Cost);

        //処理3費用
        element.odProcess3Cost = formatStringToCurrency(element.odProcess3Cost);

        //処理4費用
        element.odProcess4Cost = formatStringToCurrency(element.odProcess4Cost);

        return element;
      });

      //読み込み回数=1
      if (this.numLoads == 1) {
        //比較用詳細情報
        this.cmpDetailResult = JSON.parse(
          JSON.stringify(this.extractDetail(this.internalProcessTableData))
        );
        this.numLoads = this.numLoads + 1;
      }

      this.showFlag = false;
    },

    //Enter処理
    focusNextInput(index, columnProp) {
      let columnIndex = this.columnEditable.indexOf(columnProp);

      if (columnIndex == -1) {
        columnIndex = 0;
      }

      index = index + 1;

      if (index > this.internalProcessTableData.length - 1) {
        this.$refs[`input${0}`][columnIndex].focus();
      } else {
        this.$refs[`input${index}`][columnIndex].focus();
      }
    },

    //小計値の更新
    changeCellData(curRow) {
      //小計
      curRow.odInternalSumCost = formatStringToCurrency(
        formatCurrencyToNumber(curRow.odMaterialCost) +
          formatCurrencyToNumber(curRow.odMachineCost) +
          formatCurrencyToNumber(curRow.odProcess1Cost) +
          formatCurrencyToNumber(curRow.odProcess2Cost) +
          formatCurrencyToNumber(curRow.odProcess3Cost) +
          formatCurrencyToNumber(curRow.odProcess4Cost)
      );

      //材料費
      curRow.odMaterialCost = formatStringToCurrency(curRow.odMaterialCost);

      //加工費
      curRow.odMachineCost = formatStringToCurrency(curRow.odMachineCost);

      //処理1費用
      curRow.odProcess1Cost = formatStringToCurrency(curRow.odProcess1Cost);

      //処理2費用
      curRow.odProcess2Cost = formatStringToCurrency(curRow.odProcess2Cost);

      //処理3費用
      curRow.odProcess3Cost = formatStringToCurrency(curRow.odProcess3Cost);

      //処理4費用
      curRow.odProcess4Cost = formatStringToCurrency(curRow.odProcess4Cost);

      // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
      this.$set(this.internalProcessTableData, curRow.index, curRow);
      // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑
    },

    //セルデータの数字変換
    // UPD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
    // changeCellDataToNumber(curRow, columnName) {
    changeCellDataToNumber(curRow, columnName, $event) {
      this.selectValue($event);
      // UPD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑
      curRow[columnName] = formatCurrencyToNumber(curRow[columnName]);
    },

    //テーブルの高さを設定する
    handleResize() {
      this.detailHeight = getDialogContentHeight(
        window.innerHeight,
        0,
        DIALOG_LINE_HEIGHT,
        20
      );
    },

    // 初期化
    init() {
      this.showFlag = true;

      //検索処理
      this.searchClick();

      //列幅に自動調整
      // setColumnWidth(this.columns, this.internalProcessTableData);
    },

    // 検索
    searchClick() {
      if (!this.showFlag) {
        this.showFlag = true;
      }

      //新規の場合、前画面からデータを表示
      if (this.isAdd) {
        this.internalProcessTableData = this.preProducts;

        //読み込み回数=1
        if (this.numLoads == 1) {
          //比較用詳細情報
          this.cmpDetailResult = JSON.parse(
            JSON.stringify(this.extractDetail(this.internalProcessTableData))
          );
          this.numLoads = this.numLoads + 1;
        }

        this.showFlag = false;
      } else {
        //編集の場合、DBからデータを表示
        //前画面から正常製品の取得
        var tempTableData = this.preProducts.filter(
          (item) => item.odProdExKbnStr === "-"
        );

        searchProcessCostByOrderNo(this.orderEditForm)
          .then((res) => {
            tempTableData.forEach((item) => {
              const match = res.find(
                (rItem) => rItem.odOrderDetailNo === item.odOrderDetailNo
              );
              if (match) {
                item.odMaterialCost = match.odMaterialCost;
                item.odMachineCost = match.odMachineCost;
                item.odProcess1Cost = match.odProcess1Cost;
                item.odProcess2Cost = match.odProcess2Cost;
                item.odProcess3Cost = match.odProcess3Cost;
                item.odProcess4Cost = match.odProcess4Cost;
              }
            });

            //編集の場合、異常情報を表示しない
            this.internalProcessTableData = tempTableData;

            this.dataProcess();
          })
          .catch((err) => {
            if (err.data != null) {
              Message.showError(
                t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
              );
            } else {
              Message.showError(
                t("message.COMMON_MESSAGE.DETAIL_SEARCH_FAILURE")
              );
            }
          })
          .finally(() => {
            this.showFlag = false;
          });
      }
    },

    //セルの配置
    tableCellClassName({ row, column, rowIndex, columnIndex }) {
      row.index = rowIndex;
      column.index = columnIndex;

      if (this.columnEditable.includes(column.property)) {
        //編集可能の背景色
        return "bg-cell-editable";
      }
    },

    //テーブルで変更される可能性のある列の取得
    extractDetail(data) {
      return data.map((item, index) => {
        return {
          index: index,
          odMaterialCost: item.odMaterialCost,
          odMachineCost: item.odMachineCost,
          odProcess1Cost: item.odProcess1Cost,
          odProcess2Cost: item.odProcess2Cost,
          odProcess3Cost: item.odProcess3Cost,
          odProcess4Cost: item.odProcess4Cost,
        };
      });
    },

    //ダイアログを閉じる
    onCancel() {
      if (
        !cmpDetailData(
          this.cmpDetailResult,
          this.extractDetail(this.internalProcessTableData)
        )
      ) {
        return new Promise((resolve, reject) => {
          Modal.showWarning(
            "",
            t("message.COMMON_MESSAGE.DATA_ALREADY_CHANGED_CLOSE"),
            {
              $type: "prompt",
              confirmButtonText: t("resource.button.sure"),
              cancelButtonText: t("resource.button.cancel"),
              showCancelButton: true,
            }
          )
            .then(() => {
              // 用户点击确认
              resolve(true);
            })
            .catch((error) => {
              // 用户点击取消或关闭对话框
              resolve(false);
            });
        });
      } else {
        return true;
      }
    },
  },
};
</script>
<style scoped>
.editInput {
  width: 92%;
  height: 17px;
}
</style>
